import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import { userAddNewPassword } from "../store/actions/User";

import ImgLogo from  "./img/koooviblank.gif";
import Navber from "../Navbar/UserMenu";
import Loading from "./Loading/Loading";

import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useSelector } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import './loginSignUp.css'
import {  Link  } from "react-router-dom";
const AddNewPassWord = ()=>{
 
    const data = useSelector((state)=>state?.user?.user);

 const dispatch = useDispatch();
  

  const history = useHistory();
 
 const [loader , setLoader] =useState({status:false});
 const [AddNewPassword, setAddNewPassword] = useState({user_pass:'',user_email:data?.user_email,token:data?.token
 
});

useEffect(() => {
     
 if(!data?.change_password){
       
  history.push('/login');

} })


/* Handle Signup Function */
const handleAddNewPassword=(e)=>{
  e.preventDefault();
//console.log(signup)

setLoader({status:true});
  const user = dispatch(userAddNewPassword(AddNewPassword));
  /* get response as Promise   */
  user.then(response => {
  
    if(response){
      
      history.push('/login');

    }else{


    }
    ;
   

/* resetting Login input Fields */

setAddNewPassword({user_pass:'',user_email:'',token:''

})

setLoader({status:false});


//history.push('/dashboard/profile');


  }).catch(error => {
    
/* resetting Login input Fields */
setAddNewPassword({user_pass:'',user_email:'',token:''

})
setLoader({status:false});
    console.error(error);
  });
 
  }

    return <>
    
{<>

{<Loading  Load={loader?.status}/>}
  <form onSubmit={handleAddNewPassword} >
  <div  className="ikcraft_login-signup-backgropj"><div  className="ikcraft_login-signup-card"><div  className="blank"> </div>
  <div  className="ikcraft_login-signup-card-outerj"><div  className="ikcraft_login-signup-inner">
  <div  className="ikcraft_blankRight ikcraft_login-signup-right-signup">
      <div></div>
      <div><Link  style={{ float:'left'
    ,padding:'10px 25px',
  textDecoration: 'none',
  position: 'relative',
  top: '2px',
  fontSize: '65px',textAlign:'center',
  border: '0px',
  fontWeight: 'bold',
  background: 'linear-gradient(270deg, #E02CD3 20.56%, #6243EB 56.63%, #0952FF 69.98%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}}  to="">
               
                <span >ClassMock</span>
                </Link> </div>   <div>  </div>
    </div>  <div  className="ikcraft_login-signup-left-signup ">
      <h1 style={{"textAlign":"center"}}> Add New Password </h1>
      
 <div  className="ikcraft_login-input-card">
 <input className="ikcraft_input-textbox" required placeholder="New Password" type="text"
  name="user_pass" value={AddNewPassword.user_pass} 
  onChange={(e)=>setAddNewPassword({...AddNewPassword, user_pass : e.target.value})} />
   </div>
	  
   
   
    
   
     
   
	
	<div  className="ikcraft_login-input-card">
   
  <button  className="ikcraft_login-signup-button" type="submit" id="signupBtn">Update New Password</button>
      
  </div>

  <div> 
    
    
    
    
  </div>
 </div>
    
    
  </div></div><div></div></div></div>
   </form>
</>}
    </>

}
export default AddNewPassWord;